import React, { ReactElement, useEffect, useState } from 'react';
import {
  generatePath, useHistory, useLocation, useParams,
} from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Alert, Spin } from 'antd';
import { isMobile } from 'react-device-detect';
import { useBreakpoint } from '../../../../hooks/useBreakpoint';
import PersonalData from '../../components/personalData/personalData';
import Activity from '../../components/activity/activity';
import ModalTests from '../../components/modalTests/modalTests';
import ModalCoupon from '../../components/modalCoupon/modalCoupon';
import NavBar from '../../components/patientFile/navBar';
import {
  ROUTE_PACIENTES_GDPR,
} from '../../../../routes.constants';
import {
  getPaciente, getPacienteNotas, getPacienteRGPD, getActivity, getPhotoPaciente,
} from '../../../../state/actions/creators/pacientes.actioncreator';
import PurchaseResume from '../../components/patientFile/purchaseResume';
import { getGraduaciones } from '../../../../state/actions/creators/fichaOptometrica.actioncreator';
import gdprPrint from '../../components/gdpr/gdprPrint';
import MessageAlert from '../../components/messageAlert/messageAlert';
import {
  ShowIf,
  Text,
} from '../../../shared/components';
import { getGraduacionesContactologicas } from '../../../../state/actions/creators/fichaContactologica.actioncreator';
import FullPage from '../../../shared/components/layout/FullPage.layout';
import { MAX_WIDTH } from '../../../../state/actions/constants/app.constants';
import {isTablet} from "../../../../helpers/device.helper";


interface contentTable {
  [key: string]: ReactElement;
}

function PatientFile({ intl }: any) {
  const params: any = useParams();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const print = queryParams.get('print');
  const saved = queryParams.get('saved');
  const dispatch = useDispatch();
  const tiendaId = useSelector((state: any) => state.auth.user.user_info.tienda_id);
  const pacientesWorkspace = useSelector((state: any) => state.pacientesWorkspace);
  const { pacienteSelected } = pacientesWorkspace;
  const { loadingPacientes } = pacientesWorkspace;
  const { grpd, pdf } = pacientesWorkspace;
  const { condiciones, condiciones_adicionales } = grpd;
  const { encargos } = pacientesWorkspace;
  const ultimoEncargo = encargos.length ? encargos[0] : null;
  const lgWidth = useBreakpoint();
  const history = useHistory();
  const [modalNewTest, setModalNewTest] = useState(false);
  const [modalCoupon, setModalCoupon] = useState(false);
  const [tabState, setTabState] = useState('DatosPersonales');
  const deviceMobile = isMobile;

  const tabListNoTitle = [
    {
      key: 'Actividad',
      tab: `${intl.formatMessage({ id: 'pacientes.client_file.activity' })}`,
    },
    {
      key: 'DatosPersonales',
      tab: `${intl.formatMessage({ id: 'pacientes.client_file.personal_data' })}`,
    },
  ];

  useEffect(() => {
    const { pacienteId } = params;
    if (pacienteId) {
      const storageInfoPatientFileId = sessionStorage.getItem('infoPatientFileId');
      if(storageInfoPatientFileId !== pacienteId){;
        sessionStorage.setItem('infoPatientFileId', pacienteId);
        dispatch(getPaciente({
          tiendaId,
          pacienteId: parseInt(pacienteId, 10),
        }));
        dispatch(getPhotoPaciente({
          pacienteId: parseInt(pacienteId, 10),
        }));
        dispatch(getPacienteNotas({ pacienteId }));
        dispatch(getPacienteRGPD({
          pacienteId,
        }));
      }
      if(sessionStorage.getItem('infoPacienteActivityData') !== pacienteId) {
        dispatch(getActivity(
          pacienteId,
        ));
      }      
      // dispatch(getGraduaciones(pacienteId));
      // dispatch(getGraduacionesContactologicas(pacienteId));
    }
    if (saved === 'success') {
      MessageAlert('La ficha del cliente actualizada con éxito');
    }
  }, [params, print]);

  useEffect(() => {
    const { pacienteId } = params;
    // if(grpd){
    //   dispatch(getPaciente({ tiendaId, pacienteId }));
    // }
    if (grpd && print === 'true') {
      gdprPrint(condiciones, condiciones_adicionales,
        intl.formatMessage({ id: 'pacientes.client_file.gdpr' }));
    }
  }, [grpd]);

  const contentList: contentTable = {
    Actividad: <Activity pacientesWorkspace={pacientesWorkspace} />,
    DatosPersonales: <PersonalData />,
  };

  function onTabChange(key: any) {
    setTabState(key);
  }

  function closeModal() {
    setModalNewTest(false);
    setModalCoupon(false);
  }

  const spanContent = (
    <div className="alertContent">
      <span>{intl.formatMessage({ id: 'pacientes.client_file.must_sign' })}</span>
      <span
        className="blueLink"
        style={{ marginRight: 16, flexShrink: 0 }}
        onClick={() => history.push(generatePath(ROUTE_PACIENTES_GDPR,
          { pacienteId: pacienteSelected.id }))}
      >
        {intl.formatMessage({ id: 'pacientes.client_file.sign_now' })}
      </span>
    </div>
  );
  const patientFile: ReactElement = (
    <div>
      <ModalTests pacienteSelected={pacienteSelected} closeModal={closeModal} modalState={modalNewTest} />
      <ModalCoupon closeModal={closeModal} modalState={modalCoupon} />
      <Spin spinning={loadingPacientes && !pacienteSelected} size="large">
        { pacienteSelected && pacienteSelected.rgpd_firmada
          ? null
          : (
            <>
              {pacienteSelected
              && (
              <Alert
                className="alertRGPD"
                message=""
                description={spanContent}
                type="warning"
                showIcon
                closable
              />
              )
              }
            </>
          )
      }
        <ShowIf condition={pacienteSelected}>
          <NavBar
            pacienteSelected={pacienteSelected}
            grpd={pdf}
            deviceMobile={deviceMobile}
          />
          {(isTablet() || lgWidth.isTablet) && ultimoEncargo
            ? (
              <PurchaseResume encargos={encargos} encargo={ultimoEncargo} />
            )
            : <></>
        }
          <div className="bodyPage">
            {lgWidth.isDesktop && !isTablet() ? (
              <div className="lgWidthContainer">
                <Card
                  style={{ width: '345px', minWidth: '345px' }}
                  headStyle={{ fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.65)' }}
                  title={intl.formatMessage({ id: 'pacientes.client_file.personal_data' })}
                  className="dataCard"
                  bordered={false}
                >
                  <PersonalData />
                </Card>
                <div className="activityContainer">
                  <ShowIf condition={ultimoEncargo}><PurchaseResume encargo={ultimoEncargo} encargos={encargos} /></ShowIf>
                  <Card
                    style={{ maxWidth: `${MAX_WIDTH}px` }}
                    headStyle={{ fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.65)' }}
                    title={intl.formatMessage({ id: 'pacientes.client_file.activity' })}
                    className="activityCard activity"
                    bordered={false}
                  >
                    <Activity pacientesWorkspace={pacientesWorkspace} />
                  </Card>
                </div>
              </div>
            ) : (
              <Card
                style={{ maxWidth: `${MAX_WIDTH}px` }}
                tabList={tabListNoTitle}
                activeTabKey={tabState}
                onTabChange={(key) => {
                  onTabChange(key);
                }}
                className={tabState == 'Actividad' ? 'activity' : ''}
                bordered={false}
              >
                {contentList[tabState]}
              </Card>
            )}
          </div>
        </ShowIf>
      </Spin>
    </div>
  );

  const titulo: ReactElement = (
    <span>
      <Text
        upperCase={false}
        lowerCase={false}
        translationId={null}
        fontSize="24"
        mb={0}
      >
        {pacienteSelected ? `${pacienteSelected.nombre_completo}` : `Ficha (${params.pacienteId})`}
      </Text>
      &nbsp;
      { pacienteSelected && (
        <Text
          upperCase={false}
          lowerCase={false}
          translationId={null}
          fontSize="24"
          mb={0}
          color="rgba(0, 0, 0, 0.45)"
        >
          {`(${pacienteSelected.nombre_sucursal})`}
        </Text>
      )}
    </span>
  );

  return (
    <FullPage
      overrideMaxWidth
      titulo={titulo}
      navigationItems={[
        {
          node: <Text children="" upperCase={false} lowerCase={false} translationId="navegacion.home" />,
          link: '',
        },
        {
          node: <Text children="" upperCase={false} lowerCase={false} translationId="navegacion.pacientes" />,
          link: '/pacientes/buscar',
        },
      ]}
      loading={!pacienteSelected}
      hasStickyActionsHeader
    >
      <div className="patient patient-file">
        {patientFile}
      </div>
    </FullPage>
  );
}

export default injectIntl(PatientFile);
